import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import UnmapRevitValue from "./UnmapRevitValue.graphql";

export default function useUnmapRevitValue(
    id
) {
    return useMutation(
        gql(UnmapRevitValue),
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                "RevitValues",
            ],
            variables: {
                id,
            },
        },
    );
}
